// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"27c0d0dd","252":"8ccf2cae","384":"a3e63837","453":"68693753","706":"a17d8074"}[chunkId] + ".chunk.js";
};